import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 仓储管理--合同类型
 */
class StoreContractType extends UltMeta {
    WAREHOUSING = new Meta(11, "仓储合同");
    REGULATORY = new Meta(12, "监管合同");
    MORTGAGE = new Meta(13, "抵押合同");
    PLEDGE = new Meta(14, "质押合同");
    LOAN_AGREEMENT = new Meta(5, "借款合同");
    // WAREHOUSING = new Meta(11, "仓储合同");
    SUPPLEMENTAL_AGREEMENT = new Meta(9, "补充协议");
    OTHER = new Meta(10, "其他");
}

export const STORE_CONTRACT_TYPE = new StoreContractType();
